import { Field, Model } from 'serialize-ts';

@Model()
export class Promotion {
  
  @Field()
  totalCount: number;
}
